document.addEventListener("DOMContentLoaded", () => {
    const postCard = document.querySelector(".Postcard_Contact");
    const contactForm = document.querySelector(".Postcard_Contact form");
    const postcardSentSection = document.querySelector(".Postcard_Sent_Section");

    if(!postCard || !contactForm || !postcardSentSection) return;

    // Catch form submit event, override it and send data to the server
    contactForm.addEventListener("submit", (e) => {
        e.preventDefault();
        e.stopPropagation();

        const inputs = contactForm.querySelectorAll("[name]");
        
        const formData = new FormData(contactForm);
        const bodyString = new URLSearchParams(formData).toString();
        const body = getUrlString(formToJSON(inputs));

        fetch('/contact', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
				'Accept': 'text/html, */*; q=0.01',
				'X-Requested-With': 'XMLHttpRequest'
            },
            body: body
        })
        .then(res => {
            console.log(res);
            const feedback = postCard.querySelector(".Contact_Form_Feedback");
            if(res.status === 200){
                postCard.classList.add("Sent");
                postcardSentSection.classList.add("Shown");
            } else {
                feedback.style.color = "red";
                feedback.innerHTML = "<p>There was an error sending the message</p>";
                setTimeout(() => {
                    feedback.innerHTML = "";
                }, 5000);
            }
        });
    });

    postcardSentSection.querySelector(".Button").addEventListener("click", () => {
        postCard.classList.remove("Sent");
        postcardSentSection.classList.remove("Shown");

        const inputs = contactForm.querySelectorAll("[name]");

        inputs.forEach(input => {
            input.value = "";
        });
    });
});


// Retrieves input data from a form and returns it as a JSON object:
function formToJSON(elements) {
	return [].reduce.call(elements, function (data, element) {
		data[element.name] = element.value;
		return data;
	}, {});
}

// Get Shopify Friendly URL String
function getUrlString(data) {
	var urlParameters = Object.entries(data).map(function (e) {
		return e.join('=');
	}).join('&');

	return urlParameters;
}

function getUrlParameter(sParam) {
    var sPageURL = decodeURIComponent(window.location.search.substring(1)),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : sParameterName[1];
        }
    }
}